import { updatePieDataSettingsAction } from 'store/reducers/visualisations/actions';
import { store } from 'store';
import { OnChangeValue } from 'modules/visualisations/Pie/settings/DataTab/types';
import {
  ColorByInterface,
  DefaultPropertiesInterface,
  GroupByDateInterface,
  PieDataSettings,
  PieIndicatorDesignInterface,
  PieIndicatorLabelFormatType,
  PieIndicatorValueFormatType,
  PieRoseTypeTypes,
} from 'store/reducers/visualisations/types';
import { moveArrayItem, MoveToType } from 'utils/utils';
import { PaletteValuesByThemeType } from 'modules/settingsContainer/ColorPicker/types';

const dispatch = store.dispatch;

export const onColorBySettingsChange = (colorBySettings: ColorByInterface) =>
  dispatch(updatePieDataSettingsAction({ colorBySettings }));

export const onColorByValueSettingsChange = (colorByValueSettings: ColorByInterface) =>
  dispatch(updatePieDataSettingsAction({ colorByValueSettings }));
/* Incision change */

export const onChangeIncisionDateSettings: OnChangeValue<GroupByDateInterface> = (dataSettings, dateValue, id) =>
  dispatch(
    updatePieDataSettingsAction({
      incisions: dataSettings.incisions.map((incision) =>
        id === incision.id
          ? {
              ...incision,
              settings: { ...incision.settings, groupByDateSettings: { ...incision.settings.groupByDateSettings, ...dateValue } },
            }
          : incision,
      ),
    }),
  );

export const onColorIncisionChange: OnChangeValue<PaletteValuesByThemeType | null> = (dataSettings, colors, id) =>
  dispatch(
    updatePieDataSettingsAction({
      incisions: dataSettings.incisions.map((incision) => (id === incision.id ? { ...incision, colors } : incision)),
    }),
  );

export const onMoveIncision = (dataSettings: PieDataSettings, incisionId: string, moveTo: MoveToType) => {
  const incisions = dataSettings.incisions,
    indexOfIncision = incisions.findIndex(({ id }) => id === incisionId),
    { newArray } = moveArrayItem(incisions, indexOfIncision, moveTo);
  const newIncisions = [...newArray];

  dispatch(
    updatePieDataSettingsAction({
      incisions: newIncisions,
    }),
  );
};

/* Indicator change */

export const onChangeIndicatorStyledSettings: OnChangeValue<PieIndicatorDesignInterface> = (dataSettings, styleSettings, id) =>
  dispatch(
    updatePieDataSettingsAction({
      indicators: dataSettings.indicators.map((indicator) =>
        id === indicator.id ? { ...indicator, settings: { ...indicator.settings, styleSettings } } : indicator,
      ),
    }),
  );

export const onChangeIndicatorLabelFormat: OnChangeValue<PieIndicatorLabelFormatType[]> = (dataSettings, labelFormat, id) =>
  dispatch(
    updatePieDataSettingsAction({
      indicators: dataSettings.indicators.map((indicator) =>
        id === indicator.id ? { ...indicator, settings: { ...indicator.settings, labelFormat } } : indicator,
      ),
    }),
  );

export const onChangeIndicatorLabelProperties: OnChangeValue<DefaultPropertiesInterface> = (dataSettings, properties, id) =>
  dispatch(
    updatePieDataSettingsAction({
      indicators: dataSettings.indicators.map((indicator) =>
        id === indicator.id ? { ...indicator, settings: { ...indicator.settings, properties } } : indicator,
      ),
    }),
  );

export const onChangeIndicatorValueFormat: OnChangeValue<PieIndicatorValueFormatType> = (dataSettings, valueFormat, id) =>
  dispatch(
    updatePieDataSettingsAction({
      indicators: dataSettings.indicators.map((indicator) =>
        id === indicator.id ? { ...indicator, settings: { ...indicator.settings, valueFormat } } : indicator,
      ),
    }),
  );

export const onChangeRoseType = (roseType: PieRoseTypeTypes) =>
  dispatch(
    updatePieDataSettingsAction({
      roseType,
    }),
  );
